import type { CSSProperties } from 'react'
import type { LucideIcon } from 'lucide-react'

type AppIconSize = 'sm' | 'md' | 'lg'
type AppIconTone = 'default' | 'muted' | 'accent' | 'success' | 'warning' | 'danger' | 'info'

interface AppIconProps {
  icon: LucideIcon
  size?: AppIconSize
  tone?: AppIconTone
  contained?: boolean
  className?: string
  color?: string
}

const sizes: Record<AppIconSize, { frame: string; icon: number }> = {
  sm: { frame: 'h-8 w-8 rounded-lg', icon: 16 },
  md: { frame: 'h-10 w-10 rounded-[10px]', icon: 20 },
  lg: { frame: 'h-12 w-12 rounded-[10px]', icon: 24 },
}

const tones: Record<AppIconTone, string> = {
  default: 'text-zinc-300',
  muted: 'text-zinc-500',
  accent: 'text-brand',
  success: 'text-emerald-300',
  warning: 'text-amber-300',
  danger: 'text-red-300',
  info: 'text-blue-300',
}

export function AppIcon({ icon: Icon, size = 'md', tone = 'default', contained = true, className = '', color }: AppIconProps) {
  const config = sizes[size]
  const style: CSSProperties | undefined = color ? { color } : undefined

  return (
    <span
      aria-hidden="true"
      style={style}
      className={`inline-flex shrink-0 items-center justify-center transition-[color,background-color,transform] duration-200 ${tones[tone]} ${contained ? `border border-white/[.08] bg-white/[.035] ${config.frame}` : ''} ${className}`}
    >
      <Icon size={config.icon} strokeWidth={1.8} />
    </span>
  )
}
